/* THE FIELD — Custom Theme JS
   Handles: mobile nav toggle, quantity steppers, add-to-cart (AJAX),
   cart quantity updates, product image swap.
*/
document.addEventListener('DOMContentLoaded', function () {

  /* Mobile nav toggle */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-field-nav]');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(open));
    });
  }

  /* Product image swap */
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-full');
      var mainImg = document.querySelector('[data-main-media]');
      if (mainImg && src) {
        mainImg.setAttribute('src', src);
        mainImg.setAttribute('alt', thumb.getAttribute('data-alt') || 'Product view');
      }
      document.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-pressed', 'true');
    });
  });

  /* Quantity stepper (product + cart) */
  document.querySelectorAll('[data-qty-wrapper]').forEach(function (wrapper) {
    var input = wrapper.querySelector('input[type="number"]');
    var minus = wrapper.querySelector('[data-qty-minus]');
    var plus = wrapper.querySelector('[data-qty-plus]');
    if (!input) return;
    minus && minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    plus && plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* Shopify renders the selected combination on demand, including products with >250 variants. */
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    var product = form.closest('.field-product');
    var variantInput = form.querySelector('[data-product-variant]');
    var addButton = form.querySelector('[data-add-to-cart-btn]');
    var status = form.querySelector('[data-variant-status]');
    var price = product.querySelector('[data-product-price]');
    var sku = product.querySelector('[data-product-sku]');
    var requestNumber = 0;
    if (!variantInput || !addButton) return;

    form.querySelectorAll('[data-swatch]').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var group = swatch.closest('[data-option-group]');
        group.querySelectorAll('[data-swatch]').forEach(function (item) {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
        swatch.classList.add('is-selected');
        swatch.setAttribute('aria-pressed', 'true');

        var ids = Array.from(form.querySelectorAll('[data-option-group]')).map(function (optionGroup) {
          var chosen = optionGroup.querySelector('[data-swatch].is-selected');
          return chosen && chosen.getAttribute('data-option-value-id');
        });
        if (ids.some(function (id) { return !id; })) return;

        var currentRequest = ++requestNumber;
        variantInput.value = '';
        addButton.disabled = true;
        addButton.textContent = 'Updating…';
        status.textContent = '';
        var url = new URL(window.location.pathname, window.location.origin);
        url.searchParams.set('section_id', product.getAttribute('data-section-id'));
        url.searchParams.set('option_values', ids.join(','));

        fetch(url.toString())
          .then(function (response) {
            if (!response.ok) throw new Error('Could not load this option. Please try again.');
            return response.text();
          })
          .then(function (markup) {
            if (currentRequest !== requestNumber) return;
            var documentFromServer = new DOMParser().parseFromString(markup, 'text/html');
            var updated = documentFromServer.querySelector('[data-product-variant]');
            if (!updated) throw new Error('Could not load this option. Please try again.');
            variantInput.value = updated.value;
            var updatedButton = documentFromServer.querySelector('[data-add-to-cart-btn]');
            var available = Boolean(updated.value && updatedButton && !updatedButton.disabled);
            addButton.disabled = !available;
            addButton.textContent = available ? 'Add to Cart' : updated.value ? 'Sold Out' : 'Unavailable';
            status.textContent = available ? '' : updated.value ? 'This option is sold out.' : 'This combination is unavailable.';
            var updatedPrice = documentFromServer.querySelector('[data-product-price]');
            if (price && updatedPrice && updated.value) price.innerHTML = updatedPrice.innerHTML;
            var updatedSku = documentFromServer.querySelector('[data-product-sku]');
            if (sku) sku.textContent = updatedSku ? updatedSku.textContent : '';
            var updatedImage = documentFromServer.querySelector('[data-main-media]');
            var mainImage = product.querySelector('[data-main-media]');
            if (mainImage && updatedImage && updated.value) {
              mainImage.src = updatedImage.src;
              mainImage.alt = updatedImage.alt;
            }
            window.history.replaceState({}, '', window.location.pathname + '?option_values=' + ids.join(','));
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          })
          .catch(function (error) {
            if (currentRequest !== requestNumber) return;
            addButton.disabled = true;
            addButton.textContent = 'Unavailable';
            status.textContent = error.message || 'Could not load this option. Please try again.';
          });
      });
    });
  });

  /* Add to cart via AJAX */
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-to-cart-btn]');
      var formData = new FormData(form);
      if (btn) { btn.setAttribute('disabled', 'disabled'); btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) { return res.json().then(function (error) { throw new Error(error.description || 'Could not add this item.'); }); }
          return res.json();
        })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          if (btn) { btn.textContent = 'Added ✓'; }
          setTimeout(function () {
            if (btn) { btn.removeAttribute('disabled'); btn.textContent = 'Add to Cart'; }
          }, 1600);
        })
        .catch(function (error) {
          if (btn) { btn.removeAttribute('disabled'); btn.textContent = 'Add to Cart'; }
          var status = form.querySelector('[data-variant-status]');
          if (status) { status.textContent = error.message || 'Could not add this item. Please try again.'; }
        });
    });
  });

  /* Cart line quantity update */
  document.querySelectorAll('[data-cart-qty-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var key = input.getAttribute('data-line-key');
      var qty = parseInt(input.value, 10) || 1;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { window.location.reload(); });
    });
  });

  /* Cart line remove */
  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-line-key');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });

});
